var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"top",class:( _obj = {}, _obj[_vm.$style.top] = true, _obj[_vm.$style.hasRequests] = !!_vm.guest.requests, _obj ),attrs:{"title":_vm.guest.requests,"draggable":""},domProps:{"textContent":_vm._s(_vm.guest.sortname)},on:{"dragstart":_vm.dragStart}})}
var staticRenderFns = []

export { render, staticRenderFns }